module.exports = __webpack_public_path__ + "img/netedge-logo-new.98f7b7e1.png";